import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              WORK THAT <span className="purple"> INSPIRES </span> ME
            </h1>
            
            <p className="home-about-body">
            <span className="purple">Data Extraction & Quality Assurance</span>
              <br />
              Extracting data from relational databases and applying rigorous cleaning and transformation techniques to ensure accuracy and reliability for downstream analysis.
              <br />
              <br />
              <span className="purple">Requirements Discovery & Alignment</span>
              <br />
              Translating business challenges into structured, actionable requirements that align stakeholders and guide technical delivery.
              <br />
              <br />
              <span className="purple">Insightful Dashboards & Data Storytelling</span>
              <br />
              Designing interactive dashboards and crafting clear data narratives that empower decision-makers with evidence they can act on.
              <br />
              <br />
              <span className="purple">Process Analysis & Operational Improvement</span>
              <br />
              Mapping workflows, identifying inefficiencies, and embedding measurable, data-driven enhancements that optimise performance.
              <br />
              <br />
              <span className="purple">Strategic Analytics for Business Growth</span>
              <br />
              Applying statistical and exploratory analysis to uncover trends, inform strategies, and support long-term value creation.
              <br />
              <br />
              <span className="purple">Stakeholder-Centric Communication</span>
              <br />
              Presenting findings in business language, fostering collaboration, and ensuring insights are understood and adopted across functions.
              <br />
              <br />
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>CONNECT WITH ME ON</h1>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Viraj0297"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
             
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/virajk97/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
             
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
